export const SET_MENU_DATA = "SET_MENU_DATA";
export const INIT_MENU_DATA = "INIT_MENU_DATA";
export const INIT_MENU_COMP = "INIT_MENU_COMP";
const initialState = {
  list_menu: [],
  loadingMenu: false,
};
export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_MENU_DATA:
      return { ...state, ...action.payload };
    case INIT_MENU_DATA: {
      return { ...state, loadingMenu: true };
    }
    case INIT_MENU_COMP: {
      return { ...state, loadingMenu: false };
    }
    default:
      return state;
  }
};
